import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, UrlTree } from '@angular/router';

import { RegistrationMode } from '~/core/models/company';
import { CompanyStore } from '../store/company.store';

@Injectable({ providedIn: 'root' })
export class RouteRedirectGuard implements CanActivate {
  private router = inject(Router);
  private companyStore = inject(CompanyStore);

  constructor() {}

  canActivate(route: ActivatedRouteSnapshot): UrlTree | boolean {
    const currentMode = this.companyStore.companySignal()?.registration_mode;

    const expectedRoute = currentMode === RegistrationMode.GLOBAL ? 'register-user' : 'register';

    const currentPath = route.routeConfig?.path;

    if (currentPath !== expectedRoute) {
      const queryParams = { ...route.queryParams };
      return this.router.createUrlTree([`/${expectedRoute}`], { queryParams });
    }

    return true;
  }
}
